export default __webpack_public_path__ + "static/realWorldImg1-a23158288b8ba71e4dce553840d2a420.webp";